export default __webpack_public_path__ + "static/gs-3-publishmodel--mobile-b992901f1a42d077cdca155caf1ccc85.jpg";